import React from 'react';
import { WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { MemberMovements, UsersWhereaboutsDay } from '@features/whereabouts/models/movements.models';
import { IconPack } from '@shared/models/company.models';
import { DailyDayCells } from './DailyDayCells';
import { MemberWrapper } from './WhereaboutsV2Styles';

interface Props {
  member: MemberMovements;
  dayData: UsersWhereaboutsDay | undefined;
  amOption: WhereaboutsOption;
  pmOption: WhereaboutsOption;
  officeNameMap: Map<number, string>;
  iconPack: IconPack;
  dateStr: string;
}

export function DailyMemberRow({ member, dayData, amOption, pmOption, officeNameMap, iconPack, dateStr }: Props) {
  return (
    <MemberWrapper>
      <DailyDayCells userId={member.id}
                     firstName={member.firstName}
                     lastName={member.lastName}
                     dayData={dayData}
                     amOption={amOption}
                     pmOption={pmOption}
                     officeNameMap={officeNameMap}
                     iconPack={iconPack}
                     dateStr={dateStr} />
    </MemberWrapper>
  );
}
